export const TEXTS = {
  PORTAL_NAME: 'User Rating',
  APP_ID_LABEL: 'PlanningIT App-ID',
  APP_ID_INPUT_MASK: 'App-',
  APP_ID_PLACEHOLDER: 'XXX',
  ACTIONS_SHOW_DETAILS: 'Details anzeigen',
  ACTIONS_ADD: 'Hinzufügen',
  ACTIONS_ADD_SUB: 'Unterbereich hinzufügen',
  UNAUTHENTICATED_PORTAL_NAME: 'User Rating',
  UNAUTHENTICATED_TEXT: 'Sie werden direkt mit Ihren Microsoft Login Daten angemeldet.',
  UNAUTHENTICATED_SUB_TITLE:
    'Achten Sie darauf, dass unser Microsoft Login Pop-up von Ihrem Browser nicht blockiert wird.',
  MODULES_TEST_BADGE: '[Test]',
  SUB_APP_OPEN: 'Öffnen',
  SUB_APP_TEST_BADGE: '[Test]',
  COLLAPSIBLE_OPEN: 'Öffnen',
  COLLAPSIBLE_TEST_BADGE: '[Test]',
  CONTENT_HEADER_MENU: 'Menü',
  DEPARTMENT_LABEL: 'Org-Einheit (FD)',
  DEPARTMENT_INPUT_MASK: 'FD',
  DEPARTMENT_MAX_LENGTH_MESSAGE: 'Bitte max. 3 Zeichen eingeben',
  DEPARTMENT_PLACEHOLDER: 'X1',
  DETAILS_APP_ARCHIVE_TOAST: 'Die App wurde erfolgreich archiviert!',
  DETAILS_APP_API_CLIPBOARD_TOAST: 'API Url wurde in die Zwischenablage kopiert!'
}
